import { ArrowUpRightIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { H2, H3, SmallParagraph, SmallText } from '../../components/typography/Typography'
import { ANALYTICS_EVENTS, track } from '../../lib/analytics'
import { featuredPressArticles, TOTAL_MENTIONS } from '../InTheNews/pressArticles'

export const PressCoverage = () => {
    return (
        <section className='flex flex-col gap-8 bg-gray-100 py-12 md:py-16'>
            <div className='flex flex-col gap-4 px-4 md:px-24'>
                <SmallText className='tracking-[0.25em] text-gray-500'>In the news</SmallText>
                <div className='flex flex-wrap items-baseline gap-x-6 gap-y-2'>
                    <H2>Press coverage</H2>
                    <SmallParagraph className='text-gray-500'>{TOTAL_MENTIONS}+ mentions</SmallParagraph>
                </div>
            </div>

            {/* Cards swipe sideways on mobile and sit in a grid from `sm` up. */}
            <div className='ml-4 lg:ml-0 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 sm:grid sm:grid-cols-2 sm:overflow-visible lg:grid-cols-3 md:px-24 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
                {featuredPressArticles.map(({ outlet, headline, url, date, logo }) => (
                    <a
                        key={url}
                        href={url}
                        target='_blank'
                        rel='noopener noreferrer'
                        onClick={() => track(ANALYTICS_EVENTS.NAV_LINK_CLICKED, { label: outlet, href: url, surface: 'home_press_coverage' })}
                        className='group flex w-[78%] shrink-0 snap-start flex-col gap-4 rounded-2xl bg-white p-5 transition-shadow hover:shadow-md sm:w-auto sm:shrink'
                    >
                        <div className='flex items-center justify-between gap-3'>
                            {logo ? (
                                <img
                                    src={logo}
                                    alt={outlet}
                                    loading='lazy'
                                    decoding='async'
                                    className='h-8 max-w-[70%] object-contain object-left'
                                />
                            ) : (
                                <SmallText className='tracking-[0.15em] text-my-orange'>{outlet}</SmallText>
                            )}
                            <SmallText className='shrink-0 normal-case tracking-normal text-gray-500'>{date}</SmallText>
                        </div>
                        <H3 className='font-normal'>{headline}</H3>
                        <span className='mt-auto inline-flex items-center gap-1.5 pt-2 text-gray-600 transition-colors group-hover:text-my-orange'>
                            <SmallParagraph className='text-inherit'>Read article</SmallParagraph>
                            <ArrowUpRightIcon className='size-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5' />
                        </span>
                    </a>
                ))}
            </div>

            <div className='px-4 md:px-24'>
                <Link
                    to='/in-the-news'
                    onClick={() => track(ANALYTICS_EVENTS.NAV_LINK_CLICKED, { label: 'All press coverage', href: '/in-the-news', surface: 'home_press_coverage' })}
                    className='group inline-flex items-center gap-1.5 border-b border-gray-900 pb-0.5 transition-colors hover:border-my-orange hover:text-my-orange'
                >
                    <SmallParagraph className='text-inherit'>See all coverage</SmallParagraph>
                    <span aria-hidden='true' className='transition-transform group-hover:translate-x-0.5'>&rarr;</span>
                </Link>
            </div>
        </section>
    )
}
